'use strict';

var regexCheck = require('../util/regex-check.js');
var asciiPunctuation = regexCheck(/[!-/:-@[-`{-~]/);
module.exports = asciiPunctuation;